module.exports = __webpack_public_path__ + "img/monitor-dashboard.ef931ade.png";